import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import productReducer from '../reducers/product';
import { getErrors } from '../../../shared/redux/selectors/errors';
import errorsReducer from '../../../shared/redux/reducers/errors';
import addOnsReducer from '../reducers/addOns';
import CompatibilityLink from '../components/CompatibilityLink';
import DetailsPrice from '../components/DetailsPrice';
import DetailsInfoBanners from '../components/DetailsInfoBanners';
import AddToCartForm from '../components/AddToCartForm';
import EnergyStarIcon from '../../../shared/icons/icon-energy-star.svg';
import QmeritIcon from '../../../shared/icons/icon-qmerit.svg';
import WaterSenseIcon from '../../../shared/icons/icon-water-sense.svg';
import BestSellerIcon from '../../../shared/icons/icon-best-seller.svg';
import NewIcon from '../../../shared/icons/icon-new-badge.svg';
import PromotionBanner from '../components/PromotionBanner';
import StarRating from '../../../shared/components/StarRating/StarRating';
import Analytics from '../../../analytics/Analytics';
import DlcCertified from "../../../shared/icons/icon-dlc-certified.svg"
import MarketplaceTooltip from '../../../shared/components/MarketplaceTooltip/MarketplaceTooltip';
import {
  getCarouselImages,
  getNormalizedProduct,
  getPrice,
  getInfoBanner,
  getPromotionBanners,
  getAddOns,
  getAddOnRestriction,
} from '../selectors/product';
import { getLargeAppliancesAttributes } from '../../../shared/redux/selectors/externalAddOns';
import PhotoCarousel from '../../../shared/components/PhotoCarousel/PhotoCarousel';
import externalAddOnsReducerForProducts from '../../../shared/redux/reducers/externalAddOns';
import BrandReturnPolicy from '../components/BrandReturnPolicy';
import getValueFromWindow from '../../../shared/helpers/getValueFromWindow';


const mapStateToProps = state => ({
  inFlight: state.product.inFlight,
  addOns: getAddOns(state),
  addOnRestriction: getAddOnRestriction(state),
  carouselImages: getCarouselImages(state),
  product: getNormalizedProduct(state),
  largeApplianceAttributes: getLargeAppliancesAttributes(getNormalizedProduct(state))(state),
  promotionBanners: getPromotionBanners(state),
  priceDisplay: getPrice(state),
  errors: getErrors(state),
  infoBanner: getInfoBanner(state),
  item:{
         options:[],
         rebatePrice:state.product.details.rebatePrice,
         price:state.product.details.price,
         rebatesApplied:{rebates:[]}
       },
});

class Details extends Component {
  static isUserBlockingOnError() {
    return true;
  }

  static getDomId() {
    return 'product_details';
  }

  static getStore() {
    const { product } = window.seMarketplace;

    if (!product) {
      return null;
    }

    const middleware = [thunk];
    const initialState = {
      product: {
        details: product,
        inFlight: false,
      },
      addOns: [],
      errors: [],
      externalAddOns: {},
    };
    const composeEnhancers = (
      process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    return createStore(
      combineReducers({
        product: productReducer,
        errors: errorsReducer,
        addOns: addOnsReducer,
        externalAddOns: externalAddOnsReducerForProducts,
      }),
      initialState,
      composeEnhancers(applyMiddleware(...middleware)),
    );
  }

  constructor(props) {
    super(props);

    this.headerBanner = window.seMarketplace.slot_header_banner;
    this.analytics = new Analytics();
    this.isSMB = getValueFromWindow('site_globals', 'isSMB');
  }

  componentDidMount() {
    const { product } = this.props;

    this.analytics.productDetailImpression(product);
  }

  renderBestSeller() {
    const { product } = this.props;
    const { bestSeller, newProduct } = product;

    if (newProduct) {
      return (
        <div className="product-details__bestSeller">
          <NewIcon className="product-details__new-badge-icon" />
          <span className="product-details__new-badge-text">New!</span>
        </div>
      );
    }
    if (bestSeller) {
      return (
        <div className="product-details__bestSeller">
          <BestSellerIcon className="product-details__bestSeller__icon" />
          <span className="product-details__bestSeller__text">Top Seller</span>
        </div>
      );
    }

    return null;
  }

  renderProductInfoHeading() {
    const {
      product: {
        productName,
        model,
        ratingSummary,
        availableForFreeShipping,
      },
    } = this.props;

    const marketplaceTooltipMessage = "Get FREE shipping on your entire order with this item in your cart. Excludes large appliances."

    return (
      <>
        {availableForFreeShipping && (
          <div className="order-totals__entry">
            <div className="order-totals__entry-tax">
              <MarketplaceTooltip
                  id="shipping_tooltip"
                  display
                  title="FREE Shipping"
                  styleFlag="tax"
                  message={marketplaceTooltipMessage}
                />
            </div>
          </div>
        )}
        <h1 className="product-details__title">
          {productName}
        </h1>
        <div className="product-details__sub-info">
          <div className="product-details__model">
            {this.renderBestSeller()}
            {`Model ${model}`}
          </div>
          <StarRating {...ratingSummary} link={ratingSummary.anchor} linkCTA="See reviews" />
        </div>
      </>
    );
  }

  renderPromotion() {
    const {
      product: {
        promotions,
      },
    } = this.props;

    if (promotions) {
      return promotions.map(promotion => (
        <PromotionBanner
          body={promotion.body}
          modalHeadingLarge={promotion.modalHeadingLarge}
          modalHeadingSmall={promotion.modalHeadingSmall}
          modalMarkdown={promotion.modalMarkdown}
          modalTrigger={promotion.modalTrigger}
          modalContentLabel={promotion.modalContentLabel}
          title={promotion.title}
          type={promotion.type}
          key={promotion.uuid}
        />
      ));
    }

    return null;
  }

  renderProductInfoBanner() {
    const { promotionBanners, infoBanner } = this.props;
    const { showInfoBannerInDetails } = infoBanner;

    return (
      <>
        {showInfoBannerInDetails && (
          <div className="product-details__banner">
            <DetailsInfoBanners
              infoBanner={infoBanner}
              promotionBanners={promotionBanners}
            />
          </div>
        )}
        {this.renderPromotion()}
      </>
    );
  }

      
      render() {
        const {
          product,
          carouselImages,
          priceDisplay,
        } = this.props;
        
        const {
          compatibilityLink,
          energyStar,
          qmerit,
          waterSense,
          coBrandingImages,
          dlcCertified,
          dropshipper
        } = product;

        const { returnPolicyLinks } = this.headerBanner || {};
        // TODO : replace true with isLargeAppliance and match the link id with dropshipper
        const currentBrand = true  && returnPolicyLinks ? returnPolicyLinks.find(link => link.id === dropshipper) : null;
    return (
      <div className="se-tier se-tier--with-bottom">
        <div className="se-container">
          <div className="se-row">
            <div className="product-details__left-col">
              <div className="product-details__info-heading--mobile">
                {this.renderProductInfoHeading()}
              </div>
             <PhotoCarousel carouselImages={carouselImages} />
            </div>
            <div className="product-details__right-col">
              <div className="product-details__info">
                <div className="product-details__info-heading--tablet">
                  {this.renderProductInfoHeading()}
                </div>
                <div className="product-details__info-row">
                  <DetailsPrice {...product} priceDisplay={priceDisplay} />
                  <div className="product-details__icon-wrapper">
                    {coBrandingImages && coBrandingImages.map(image => (
                      <img
                        key={image.id}
                        src={image.imageUrl}
                        alt="Co-Branding Logo"
                        className="product-details__co-brand-logo"
                      />
                    ))}
                    {qmerit && (
                      <QmeritIcon
                        className="product-details__qmerit"
                        role="img"
                        aria-label="Energy Star"
                      />
                    )}
                    {energyStar && (
                      <EnergyStarIcon
                        className="product-details__energyStar"
                        role="img"
                        aria-label="Energy Star"
                      />
                    )}
                    {waterSense && (
                      <WaterSenseIcon
                        className="product-details__waterSense"
                        role="img"
                        aria-label="Water Sense - Meets EPA Criteria. Certified by ICC-ES"
                      />
                    )}
                    {dlcCertified && (
                      <DlcCertified
                        className="product-details__dlcCertified"
                        role="img"
                        aria-label="DLC Certified"
                      />
                    )}    
                  </div>
                </div>
                {compatibilityLink && <CompatibilityLink url={compatibilityLink} isSmb={this.isSMB} />}
                {currentBrand && <BrandReturnPolicy currentBrand={currentBrand} />}
                {this.renderProductInfoBanner()}
                <AddToCartForm {...this.props} analytics={this.analytics} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Details.propTypes = {
  addOns: PropTypes.arrayOf(PropTypes.shape({})),
  addOnRestriction: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    price: PropTypes.shape({}).isRequired,
    bestSeller: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    energyStar: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    qmerit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    waterSense: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    coBrandingImages: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        imageUrl: PropTypes.string,
      }),
    ),
    rebates: PropTypes.shape({
      min: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      max: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      label: PropTypes.string,
      tooltip: PropTypes.string,
    }).isRequired,
    rebatePrice: PropTypes.shape({}),
    showInfoBannerInDetails: PropTypes.bool,
    newProduct: PropTypes.bool,
    ratingSummary: PropTypes.shape({
      anchor: PropTypes.string,
    }),
    promotions: PropTypes.arrayOf(PropTypes.shape({
      body: PropTypes.string,
      modalHeadingLarge: PropTypes.string,
      modalHeadingSmall: PropTypes.string,
      modalMarkdown: PropTypes.string,
      modalTrigger: PropTypes.string,
      modalContentLabel: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      uuid: PropTypes.string,
    })),
    compatibilityLink: PropTypes.string,
  }).isRequired,
  carouselImages: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  dispatch: PropTypes.func.isRequired,
  priceDisplay: PropTypes.shape({}).isRequired,
  infoBanner: PropTypes.shape({
    theme: PropTypes.string,
    message: PropTypes.string,
    showInfoBannerInDetails: PropTypes.bool,
  }),
  promotionBanners: PropTypes.arrayOf(PropTypes.shape({})),
  inFlight: PropTypes.bool.isRequired,
  item:PropTypes.shape({
    options:PropTypes.array,
    rebatePrice:PropTypes.shape({
      sales:PropTypes.shape({
        value:PropTypes.number
      })}),
    price:PropTypes.shape({
      sales:PropTypes.shape({
        value:PropTypes.number
      })}),
    rebatesApplied:PropTypes.shape({
      rebates:PropTypes.array
    })
  })
};

Details.defaultProps = {
  addOns: [],
  addOnRestriction: null,
  infoBanner: {
    theme: undefined,
    message: undefined,
  },
  promotionBanners: [],
};

export default connect(mapStateToProps)(Details);
